/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-writings.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '../shared/config.service';
import * as import9 from '../shared/utils.service';
import * as import10 from '../shared/content.service';
import * as import11 from '@angular/router/src/router_state';
import * as import12 from '@angular/common/src/location/location';
import * as import13 from '@angular/router/src/router';
import * as import14 from '@angular/core/src/metadata/view';
import * as import15 from '@angular/core/src/linker/component_factory';
import * as import16 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import17 from '@angular/common/src/pipes/date_pipe';
import * as import18 from '@angular/core/src/linker/template_ref';
import * as import19 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import20 from '@angular/core/src/i18n/tokens';
import * as import21 from '@angular/common/src/directives/ng_for';
import * as import22 from '../../../node_modules/@angular/forms/src/directives/checkbox_value_accessor.ngfactory';
import * as import23 from '../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import24 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import25 from '@angular/core/src/linker/element_ref';
import * as import26 from '@angular/forms/src/directives/checkbox_value_accessor';
import * as import27 from '@angular/forms/src/directives/control_value_accessor';
import * as import28 from '@angular/forms/src/directives/ng_model';
import * as import29 from '@angular/forms/src/directives/ng_control';
import * as import30 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_ContentWritingsComponent {
  context:import0.ContentWritingsComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any) {
    this.changed = false;
    this.context = new import0.ContentWritingsComponent(p0,p1,p2,p3,p4,p5);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentWritingsComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentWritingsComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _ContentWritingsComponent_0_4:Wrapper_ContentWritingsComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent_Host0,renderType_ContentWritingsComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'ng-component',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentWritingsComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._ContentWritingsComponent_0_4 = new Wrapper_ContentWritingsComponent(this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import9.UtilsService),this.parentInjector.get(import10.ContentService),this.parentInjector.get(import11.ActivatedRoute),this.parentInjector.get(import12.Location),this.parentInjector.get(import13.Router));
    this._appEl_0.initComponent(this._ContentWritingsComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._ContentWritingsComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.ContentWritingsComponent) && (0 === requestNodeIndex))) { return this._ContentWritingsComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentWritingsComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._ContentWritingsComponent_0_4.context.ngAfterContentChecked(); }
    this._ContentWritingsComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingsComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentWritingsComponent_Host === (null as any))) { (renderType_ContentWritingsComponent_Host = viewUtils.createRenderComponentType('',0,import14.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentWritingsComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentWritingsComponentNgFactory:import15.ComponentFactory<import0.ContentWritingsComponent> = new import15.ComponentFactory<import0.ContentWritingsComponent>('ng-component',viewFactory_ContentWritingsComponent_Host0,import0.ContentWritingsComponent);
const styles_ContentWritingsComponent:any[] = ([] as any[]);
var renderType_ContentWritingsComponent:import2.RenderComponentType = (null as any);
class _View_ContentWritingsComponent0 extends import1.AppView<import0.ContentWritingsComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _text_38:any;
  _el_39:any;
  _text_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _text_44:any;
  _text_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _anchor_49:any;
  /*private*/ _appEl_49:import3.AppElement;
  _TemplateRef_49_5:any;
  _NgFor_49_6:import16.Wrapper_NgFor;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  _text_54:any;
  _text_55:any;
  _text_56:any;
  /*private*/ _expr_60:any;
  _pipe_date_0:import17.DatePipe;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent0,renderType_ContentWritingsComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_60 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','content-header'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'h1',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'Ecrits\n    ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'a',new import4.InlineArray2(2,'class','lLink'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n      ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'div',new import4.InlineArray2(2,'class','btn btn-default btn-sm'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'Nouveau',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_11 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','content'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n  ',(null as any));
    this._el_14 = import4.createRenderElement(this.renderer,this._el_12,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n  ',(null as any));
    this._el_16 = import4.createRenderElement(this.renderer,this._el_14,'div',new import4.InlineArray2(2,'class','col-xs-12'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n  ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_16,'div',new import4.InlineArray2(2,'class','box'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n    ',(null as any));
    this._el_20 = import4.createRenderElement(this.renderer,this._el_18,'div',new import4.InlineArray2(2,'class','box-body'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n\n      ',(null as any));
    this._el_22 = import4.createRenderElement(this.renderer,this._el_20,'table',new import4.InlineArray2(2,'class','table table-striped table-hover'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n        ',(null as any));
    this._el_24 = import4.createRenderElement(this.renderer,this._el_22,'thead',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'\n          ',(null as any));
    this._el_26 = import4.createRenderElement(this.renderer,this._el_24,'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n            ',(null as any));
    this._el_28 = import4.createRenderElement(this.renderer,this._el_26,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'Statut',(null as any));
    this._text_30 = this.renderer.createText(this._el_26,'\n            ',(null as any));
    this._el_31 = import4.createRenderElement(this.renderer,this._el_26,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'Auteur',(null as any));
    this._text_33 = this.renderer.createText(this._el_26,'\n            ',(null as any));
    this._el_34 = import4.createRenderElement(this.renderer,this._el_26,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'Titre ',(null as any));
    this._el_36 = import4.createRenderElement(this.renderer,this._el_34,'small',new import4.InlineArray2(2,'class','table-language'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'',(null as any));
    this._text_38 = this.renderer.createText(this._el_26,'\n            ',(null as any));
    this._el_39 = import4.createRenderElement(this.renderer,this._el_26,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_40 = this.renderer.createText(this._el_39,'Date',(null as any));
    this._text_41 = this.renderer.createText(this._el_26,'\n            ',(null as any));
    this._el_42 = import4.createRenderElement(this.renderer,this._el_26,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'Modifié',(null as any));
    this._text_44 = this.renderer.createText(this._el_26,'\n          ',(null as any));
    this._text_45 = this.renderer.createText(this._el_24,'\n        ',(null as any));
    this._text_46 = this.renderer.createText(this._el_22,'\n        ',(null as any));
    this._el_47 = import4.createRenderElement(this.renderer,this._el_22,'tbody',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n          ',(null as any));
    this._anchor_49 = this.renderer.createTemplateAnchor(this._el_47,(null as any));
    this._appEl_49 = new import3.AppElement(49,47,this,this._anchor_49);
    this._TemplateRef_49_5 = new import18.TemplateRef_(this._appEl_49,viewFactory_ContentWritingsComponent1);
    this._NgFor_49_6 = new import16.Wrapper_NgFor(this._appEl_49.vcRef,this._TemplateRef_49_5,this.parentInjector.get(import19.IterableDiffers),this.ref);
    this._text_50 = this.renderer.createText(this._el_47,'\n        ',(null as any));
    this._text_51 = this.renderer.createText(this._el_22,'\n      ',(null as any));
    this._text_52 = this.renderer.createText(this._el_20,'\n\n\n    ',(null as any));
    this._text_53 = this.renderer.createText(this._el_18,'\n  ',(null as any));
    this._text_54 = this.renderer.createText(this._el_16,'\n  ',(null as any));
    this._text_55 = this.renderer.createText(this._el_14,'\n  ',(null as any));
    this._text_56 = this.renderer.createText(this._el_12,'\n',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_4,'click',this.eventHandler(this._handle_click_4_0.bind(this)));
    this._pipe_date_0 = new import17.DatePipe(this.parentInjector.get(import20.LOCALE_ID));
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._text_38,
      this._el_39,
      this._text_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._text_44,
      this._text_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._anchor_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._text_53,
      this._text_54,
      this._text_55,
      this._text_56
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.TemplateRef) && (49 === requestNodeIndex))) { return this._TemplateRef_49_5; }
    if (((token === import21.NgFor) && (49 === requestNodeIndex))) { return this._NgFor_49_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_49_0_0:any = this.context.contents;
    this._NgFor_49_6.check_ngForOf(currVal_49_0_0,throwOnChange,false);
    this._NgFor_49_6.detectChangesInInputProps(this,this._anchor_49,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_60:any = import4.interpolate(1,'',this.context.currentLanguage,'');
    if (import4.checkBinding(throwOnChange,this._expr_60,currVal_60)) {
      this.renderer.setText(this._text_37,currVal_60);
      this._expr_60 = currVal_60;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_4_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>this.context.utils.lLink('admin/writing/edit/0',this.context.currentLanguage)) !== false);
    return (true && pd_4_0);
  }
}
export function viewFactory_ContentWritingsComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentWritingsComponent> {
  if ((renderType_ContentWritingsComponent === (null as any))) { (renderType_ContentWritingsComponent = viewUtils.createRenderComponentType('',0,import14.ViewEncapsulation.None,styles_ContentWritingsComponent,{})); }
  return new _View_ContentWritingsComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _CheckboxControlValueAccessor_6_3:import22.Wrapper_CheckboxControlValueAccessor;
  _NG_VALUE_ACCESSOR_6_4:any[];
  _NgModel_6_5:import23.Wrapper_NgModel;
  _NgControl_6_6:any;
  _NgControlStatus_6_7:import24.Wrapper_NgControlStatus;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  /*private*/ _expr_29:any;
  /*private*/ _expr_30:any;
  /*private*/ _expr_31:any;
  /*private*/ _expr_32:any;
  /*private*/ _expr_33:any;
  _pipe_date_0_0:any;
  /*private*/ _expr_35:any;
  _pipe_date_0_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent1,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_29 = import7.UNINITIALIZED;
    this._expr_30 = import7.UNINITIALIZED;
    this._expr_31 = import7.UNINITIALIZED;
    this._expr_32 = import7.UNINITIALIZED;
    this._expr_33 = import7.UNINITIALIZED;
    this._expr_35 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'td',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','switch material-switch'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                  ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'input',new import4.InlineArray2(2,'type','checkbox'),(null as any));
    this._CheckboxControlValueAccessor_6_3 = new import22.Wrapper_CheckboxControlValueAccessor(this.renderer,new import25.ElementRef(this._el_6));
    this._NG_VALUE_ACCESSOR_6_4 = [this._CheckboxControlValueAccessor_6_3.context];
    this._NgModel_6_5 = new import23.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_6_4);
    this._NgControl_6_6 = this._NgModel_6_5.context;
    this._NgControlStatus_6_7 = new import24.Wrapper_NgControlStatus(this._NgControl_6_6);
    this._text_7 = this.renderer.createText(this._el_4,'\n                  ',(null as any));
    this._el_8 = import4.createRenderElement(this.renderer,this._el_4,'label',new import4.InlineArray2(2,'class','label-primary'),(null as any));
    this._text_9 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._text_10 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_0,'td',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_15 = import4.createRenderElement(this.renderer,this._el_0,'td',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_0,'td',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._text_20 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_21 = import4.createRenderElement(this.renderer,this._el_0,'td',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'',(null as any));
    this._text_23 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_6,'click',this.eventHandler(this._handle_click_6_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_6,'ngModelChange',this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_6,'change',this.eventHandler(this._handle_change_6_2.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_6,'blur',this.eventHandler(this._handle_blur_6_3.bind(this)));
    const subscription_0:any = this._NgModel_6_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_15,'click',this.eventHandler(this._handle_click_15_0.bind(this)));
    this._pipe_date_0_0 = import4.pureProxy2((<_View_ContentWritingsComponent0>this.parent)._pipe_date_0.transform.bind((<_View_ContentWritingsComponent0>this.parent)._pipe_date_0));
    this._pipe_date_0_1 = import4.pureProxy2((<_View_ContentWritingsComponent0>this.parent)._pipe_date_0.transform.bind((<_View_ContentWritingsComponent0>this.parent)._pipe_date_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._text_23
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4
    ]
    ,[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import26.CheckboxControlValueAccessor) && (6 === requestNodeIndex))) { return this._CheckboxControlValueAccessor_6_3.context; }
    if (((token === import27.NG_VALUE_ACCESSOR) && (6 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_6_4; }
    if (((token === import28.NgModel) && (6 === requestNodeIndex))) { return this._NgModel_6_5.context; }
    if (((token === import29.NgControl) && (6 === requestNodeIndex))) { return this._NgControl_6_6; }
    if (((token === import30.NgControlStatus) && (6 === requestNodeIndex))) { return this._NgControlStatus_6_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this._CheckboxControlValueAccessor_6_3.detectChangesInInputProps(this,this._el_6,throwOnChange);
    const currVal_6_1_0:any = import4.interpolate(1,'',this.context.$implicit._id,'');
    this._NgModel_6_5.check_name(currVal_6_1_0,throwOnChange,false);
    const currVal_6_1_1:any = this.context.$implicit.active;
    this._NgModel_6_5.check_model(currVal_6_1_1,throwOnChange,false);
    this._NgModel_6_5.detectChangesInInputProps(this,this._el_6,throwOnChange);
    this._NgControlStatus_6_7.detectChangesInInputProps(this,this._el_6,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_29:any = import4.interpolate(1,'',this.context.$implicit._id,'');
    if (import4.checkBinding(throwOnChange,this._expr_29,currVal_29)) {
      this.renderer.setElementProperty(this._el_6,'id',currVal_29);
      this._expr_29 = currVal_29;
    }
    this._CheckboxControlValueAccessor_6_3.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._NgModel_6_5.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._NgControlStatus_6_7.detectChangesInHostProps(this,this._el_6,throwOnChange);
    const currVal_30:any = import4.interpolate(1,'',this.context.$implicit._id,'');
    if (import4.checkBinding(throwOnChange,this._expr_30,currVal_30)) {
      this.renderer.setElementAttribute(this._el_8,'for',((currVal_30 == (null as any))? (null as any): currVal_30.toString()));
      this._expr_30 = currVal_30;
    }
    const currVal_31:any = import4.interpolate(1,'',this.context.$implicit.author,'');
    if (import4.checkBinding(throwOnChange,this._expr_31,currVal_31)) {
      this.renderer.setText(this._text_13,currVal_31);
      this._expr_31 = currVal_31;
    }
    const currVal_32:any = import4.interpolate(1,'',(this.context.$implicit.title? this.context.$implicit.title[this.parent.context.currentLanguage]: '-'),'');
    if (import4.checkBinding(throwOnChange,this._expr_32,currVal_32)) {
      this.renderer.setText(this._text_16,currVal_32);
      this._expr_32 = currVal_32;
    }
    valUnwrapper.reset();
    const currVal_33:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_0,(<_View_ContentWritingsComponent0>this.parent)._pipe_date_0.transform)(this.context.$implicit.date,'MMM yyyy')),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_33,currVal_33))) {
      this.renderer.setText(this._text_19,currVal_33);
      this._expr_33 = currVal_33;
    }
    valUnwrapper.reset();
    const currVal_35:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_1,(<_View_ContentWritingsComponent0>this.parent)._pipe_date_0.transform)(this.context.$implicit.update_date,'MMM dd yyyy')),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_35,currVal_35))) {
      this.renderer.setText(this._text_22,currVal_35);
      this._expr_35 = currVal_35;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._NgModel_6_5.context.ngOnDestroy();
  }
  private _handle_click_6_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this.parent.context.onStatusChange(!this.context.$implicit.active,this.context.$implicit)) !== false);
    return (true && pd_6_0);
  }
  private _handle_ngModelChange_6_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>(this.context.$implicit.active = $event)) !== false);
    return (true && pd_6_0);
  }
  private _handle_change_6_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this._CheckboxControlValueAccessor_6_3.context.onChange($event.target.checked)) !== false);
    return (true && pd_6_0);
  }
  private _handle_blur_6_3($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this._CheckboxControlValueAccessor_6_3.context.onTouched()) !== false);
    return (true && pd_6_0);
  }
  private _handle_click_15_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_15_0:any = ((<any>this.parent.context.router.navigate([('writing/edit/' + this.context.$implicit._id)],{relativeTo: this.parent.context.route.parent})) !== false);
    return (true && pd_15_0);
  }
}
function viewFactory_ContentWritingsComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent1(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-writings.component.ngfactory.ts